var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import { useContext } from "react";
import { FormContext, emptyFormState } from "../context/form-context";
export var useForm = function (name) {
  var _a = __read(useContext(FormContext), 2),
    state = _a[0],
    setState = _a[1];
  var singleFormState = state[name] || emptyFormState;
  var setSingleFormState = function (newState) {
    var _a;
    setState(__assign(__assign({}, state), (_a = {}, _a[name] = newState, _a)));
  };
  var setValues = function (values) {
    setSingleFormState(__assign(__assign({}, singleFormState), {
      values: values
    }));
  };
  var reset = function () {
    setSingleFormState(emptyFormState);
  };
  return __assign(__assign({}, singleFormState), {
    setValues: setValues,
    patchValues: function (values) {
      if (values === void 0) {
        values = {};
      }
      setValues(__assign(__assign({}, singleFormState.values), values));
    },
    startSubmit: function () {
      setSingleFormState(__assign(__assign({}, singleFormState), {
        isSubmitting: true
      }));
    },
    endSubmit: function () {
      setSingleFormState(__assign(__assign({}, singleFormState), {
        isSubmitting: false,
        isSubmitted: true,
        values: {}
      }));
    },
    reset: reset,
    resetOnClick: function () {
      return reset();
    }
  });
};